import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { observer } from "mobx-react";
import { useParams, useNavigate } from 'react-router-dom';
import { action } from "mobx";
import { RootStoreContext } from "../../core/stores/rootStore";
import { useContext,useState } from "react";
import { useStores } from "../../core/stores/rootStore";
import Form from 'react-bootstrap/Form';
import { useTranslation, Trans } from "react-i18next";


const TwoFactorAuthentication = () => {

    let { token } = useParams();
    let navigate = useNavigate();
    const { loginStore } = useStores();
    const { t, i18n } = useTranslation();

    //const rootStore = useContext(RootStoreContext);
    const { validateCode, resetFrom2FA } = loginStore;
    const [code,setCode] = useState("");
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            validateCode(token, code).then(() => navigate("/timesheets"))
        }

        setValidated(true);
    };

    return (
        <Form noValidate onSubmit={handleSubmit}>
            <h1 className="fw-normal mb-3 pb-3">{t("welcome")}</h1>

            <label className="form-label" htmlFor="userInput">{t("pleaseEnter2FACode")}</label>

            {/*<div className="form-outline mb-2">
                <label className="form-label" htmlFor="codeInput">Code de confirmation</label>
                <div className="input-group mb-3">
                    <input type="text" id="codeInput" className="form-control" value={code} onChange={action((e) => setCode(e.target.value))} />
                    <span className="input-group-text">
                        <FontAwesomeIcon icon={solid("lock")} />
                    </span>
                </div>
            </div>*/}

            <Form.Group className="my-2">
                <Form.Label>{t('twoFactorCode')}</Form.Label>
                <Form.Control
                    autoComplete="off"
                    autoFocus
                    name="code"
                    required
                    type="number"
                    onChange={action((e) => setCode(e.target.value))}
                />
                <Form.Control.Feedback type="invalid">
                    {t('fieldRequired')}
                </Form.Control.Feedback>
            </Form.Group>

            <div className="pt-1 mb-2 d-grid">
                <button className="btn btn-secondary btn-lg btn-block" type="submit">{t("signIn")}</button>
            </div>
            <div className="pt-1 mb-2 d-grid">
                <button className="btn btn-link btn-lg btn-block" type="button" onClick={() => { resetFrom2FA(); navigate("/login"); }}>{t("cancel")}</button>
            </div>
        </Form>
    );
};

export default observer(TwoFactorAuthentication);
